import $ from 'jquery'

import Esearcher from './Esearcher/index'

const handlerTabs = (() => {

    // overlay for entire tabs system, effectively overlay for application main
    const selectorTabsOverlay = '#tab-overlay'

    const showTabsOverlay = () => {
        $(selectorTabsOverlay).show()
    }

    const hideTabsOverlay = () => {
        $(selectorTabsOverlay).hide()
    }

    // overlay for single tab panel
    const loadingIconClass = 'eii--spin eii--fa6-solid--circle-notch'
    const loadingIconDefault = `<i class="${loadingIconClass}"></i>`
    const loadingIconMedium = `<i class="${loadingIconClass} eii--2x"></i>`
    const loadingIconLarge = `<i class="${loadingIconClass} eii--5x"></i>`

    const tabLoadingIndicator = `<div id="tab-loading-indicator" class="text-center m-5">${loadingIconLarge}</div>`

    const showTabLoadingIndicator = (tab) => {
        $(tab).prepend(tabLoadingIndicator)
    }

    const hideTabLoadingIndicator = (tab) => {
        $(tab).find('#tab-loading-indicator').remove()
    }

    // tab handling
    const getActiveTab = () => {
        return $('#tabs-right .navbar .navbar-nav .nav-item[aria-expanded="true"]')
    }

    const getActiveTabId = () => {
        return getActiveTab().data('tabs-tab-id')
    }

    const getActiveTabNavLink = () => {
        return getActiveTab().find('.nav-link')
    }

    const getActiveTabPanel = () => {
        const id = getActiveTabId()
        return $(`#tabs-right .tabs-scoped-contents .tabs-scoped-content[data-tabs-tab-id="${id}"]`)
    }

    const getIdForTab = tab => {
        return $(tab).data('tabs-tab-id')
    }

    const getNavLinkForTab = tab => {
        return $(tab).find('.nav-link')
    }

    // block loader handling
    let blockLoaderRequestRoute = getActiveTabNavLink().data('route')

    const setBlockLoaderRequestRoute = (route) => {
        blockLoaderRequestRoute = route
    }

    const getBlockLoaderRequestRoute = () => {
        return blockLoaderRequestRoute
    }

    const generateBlockLoaderRequestRoute = (entityId) => {
        const id = isNaN(entityId) || entityId === 0 ? '' : entityId
        return blockLoaderRequestRoute + id + window.location.search
    }

    let entityId = null

    const selectorApplicationActionSaveNotHidden = '.application-action-save:not(.hidden)'
    const selectorApplicationActionSave = '.application-action-save'

    const showTabChangeConfirmationDialog = (ui) => {
        const formWidget = ui.oldPanel.find('form[widget="esearcher.form"]')

        if (formWidget.length === 0) return false

        const widgetById = widget.getById(formWidget.attr('widgetid'))

        if (typeof widgetById !== 'undefined' && widgetById.getStatus()) {
            const tabNewNavLink = ui.newTab.find('.nav-link')
            const tabsOverlay = $(selectorTabsOverlay)

            $('<div class="handler-tabs-main-confirmation-dialog">').dialog({
                title: tabsOverlay.data('textDialogTitle'), modal: true, buttons: [{
                    text: tabsOverlay.data('textDialogConfirm'),
                    class: 'btn btn-primary',
                    position: '.modal-footer',
                    click: () => {
                        $(selectorApplicationActionSaveNotHidden).trigger('click')

                        $('.handler-tabs-main-confirmation-dialog').dialog('destroy')

                        $(document).on('loadFinish.tabSaved', (e, data) => {
                            if (data.__messages?.error?.length === 0) {
                                widgetById.setStatus(false)
                                tabNewNavLink.trigger('click')
                            }
                            $(document).off('loadFinish.tabSaved')
                        });
                    }
                }, {
                    text: tabsOverlay.data('textDialogCancel'),
                    class: "btn btn-outline-default",
                    position: '.modal-footer',
                    click: function () {
                        $('.handler-tabs-main-confirmation-dialog').dialog('destroy')

                        widgetById.setStatus(false)
                        tabNewNavLink.trigger('click')
                    }
                }, {
                    text: '<i class="eii--fa6-solid--xmark"></i>',
                    class: 'btn btn-link',
                    position: '.modal-buttons',
                    click: function () {
                        $('.handler-tabs-main-confirmation-dialog').dialog('destroy')

                        widgetById.setStatus(false)
                        tabNewNavLink.trigger('click')
                    }
                }]
            })

            return true
        }

        return false
    }

    const makeEvent = (tabElementId, withPreventDefault) => {
        const event = {
            tab: tabElementId
        }

        if (withPreventDefault) {
            event._preventDefault = false
            event.preventDefault = () => {
                this._preventDefault = true
            }
        }

        return event;
    }

    const activateTab = (tabsContainer, tab, panel, tabOld, panelOld) => {
        deinitializeTabAndPanel(tabOld, panelOld)

        clearTabAndPanel(tabOld, panelOld)

        clearTabAndPanel(tab, panel)

        setBlockLoaderRequestRoute(getNavLinkForTab(tab).data('route'))

        showTabLoadingIndicator(panel)

        const loader = new Esearcher.BlockLoader()

        loader
            .setAssetProcessing(true)
            .mapBlocks({
                'tabContent': $(panel), 'entityHeading': $('.entity-heading, title')
            })
            .setCallback(() => {
                initializeTabAndPanel(tab, panel)

                hideTabLoadingIndicator(panel)

                const tabFinishEvent = makeEvent(getIdForTab(tab), false)
                Esearcher.trigger('tabFinish', tabFinishEvent)

                tabsContainer.tabs('enable')

                reinitializeSaveButton(entityId, panel)

                $(document).trigger('tabFinalRoute', generateBlockLoaderRequestRoute(entityId))
            })
            .request(generateBlockLoaderRequestRoute(entityId))

        $(document).trigger('tabFinalRoute', generateBlockLoaderRequestRoute(entityId));
    }

    const saveTab = (entityId, values, panel, panelId) => {
        showTabsOverlay()

        $(document).one('loadFinish', () => {
            hideTabsOverlay()

            const saveFinishEvent = makeEvent(panelId, false)
            Esearcher.trigger('saveFinish', saveFinishEvent)
        })

        const loader = new Esearcher.BlockLoader()

        loader
            .mapBlocks({
                'tabContent': panel,
                'entityHeading': $('.entity-heading, title'),
                'classifications': $('.tags'),
                'customHeading': $('.custom-heading')
            })
            .setCallback(() => {
                hideTabsOverlay()
            })
            .request(generateBlockLoaderRequestRoute(entityId), values, 'POST')
    }

    const reinitializeSaveButton = (entityId, panel) => {
        $(selectorApplicationActionSave)
            .off('click')
            .on('click', () => {
                const panelId = panel.attr('id')

                const saveEvent = makeEvent(panelId, true)
                Esearcher.trigger('save', saveEvent)
                if (saveEvent._preventDefault) {
                    return
                }

                const id = getActiveTabId()
                const values = $(`#${id}Form`).serialize()

                if (values === '') {
                    return
                }

                saveTab(entityId, values, panel, panelId)
            })
    }

    const deinitializeTabAndPanel = (tab, panel) => {
        if (tab === undefined || panel === undefined) return

        window.Esearcher.vue3initializer.deinitialize(panel[0])
    }

    const clearTabAndPanel = (tab, panel) => {
        if (tab === undefined || panel === undefined) return

        panel.html('')
    }

    const initializeTabAndPanel = (tab, panel) => {
        if (tab === undefined || panel === undefined) return

        window.Esearcher?.vue3initializer?.reinitialize()
    }

    return {
        showTabsOverlay,
        hideTabsOverlay,
        loadingIconClass,
        loadingIconDefault,
        loadingIconMedium,
        loadingIconLarge,
        getActiveTab,
        getActiveTabId,
        getActiveTabPanel,
        setBlockLoaderRequestRoute,
        getBlockLoaderRequestRoute,
        generateBlockLoaderRequestRoute,
        initialize: () => {
            const tabsContainer = $("#tabs-right")

            entityId = parseInt($('#dataId').val(), 10)

            tabsContainer.tabs({
                beforeActivate: function (event, ui) {
                    if (showTabChangeConfirmationDialog(ui)) {
                        return false
                    }

                    const newTabId = getIdForTab(ui.newTab)
                    const oldTabId = getIdForTab(ui.oldTab)

                    const tabEvent = makeEvent(newTabId, true)
                    Esearcher.trigger('tab', tabEvent)
                    if (tabEvent._preventDefault) {
                        return false
                    }

                    $(document).trigger('tabChange', {
                        newTab: newTabId, oldTab: oldTabId
                    })

                    tabsContainer.tabs('disable')

                    if (typeof event.currentTarget !== 'undefined') {
                        location.hash = event.currentTarget.hash
                    } else {
                        location.hash = '#' + newTabId
                    }

                    activateTab(tabsContainer, ui.newTab, ui.newPanel, ui.oldTab, ui.oldPanel)
                }, create: function (event, ui) {
                    tabsContainer.tabs('disable')

                    activateTab(tabsContainer, ui.tab, ui.panel, undefined, undefined)
                }
            })
        }
    }

})()

if (typeof window.Esearcher !== 'object') {
    window.Esearcher = {}
    console.log('handler-tabs-main: Missing Esearcher global') // that would be a bug
}
if (typeof window.Esearcher.handler !== 'object') {
    window.Esearcher.handler = {}
}
window.Esearcher.handler.tabs = handlerTabs

handlerTabs.initialize()

$(document).on('loadFinish', () => {
    handlerTabs.initialize()
})
